import './comment-form.scss'
import React, { useEffect, useState } from 'react';
import { sendComment } from '../../../shared/services/comments/comments';
import Toast from '../../toast/toast';
import { ShowToast, toastTypes } from '../../toast/show-tosat';
import ImageGenerator from '../../image-generator/image-generator';
import send from '../../../assets/images/send.svg';
import user from '../../../assets/images/user.svg';
import chat from '../../../assets/images/chat.svg';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import AuthenticationDialogHandler from '../../authentication-dialog-handler/authentication-dialog-handler';
import { useConfigApp } from '../../../shared/services/general/app-context';

const CommentForm = ({ programId }) => {
	const [comment, setComment] = useState('');
	const [loading, setLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState([]);
	const { profile } = useSelector(state => state.profileData);
	const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
	const configApp = useConfigApp();

	const callSendComment = () => {
		sendComment(programId, comment).then(res => {
			if (res.data.code === 200) {
				setComment(''); // پاک کردن فیلد ورودی
				setLoading(false);
				setSuccessMessage(ShowToast(toastTypes.success, 'نظر شما با موفقیت ارسال شد. پس از تایید منتشر خواهد شد'));
			}
		}).catch((error) => {
			setLoading(false);
			console.error('Error submitting comment:', error);
			if (error) {
				setSuccessMessage(ShowToast(toastTypes.error, 'ظاهرا مشکلی پیش آمده است، نظر شما ثبت نشد.'));
			}
		})
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (comment.trim()) {
			setLoading(true);
			setSuccessMessage([]); // Reset success message before API call
			callSendComment()
		}
	};

	const goToRegister = () => {
		return(
			<div className="go-to-register">
				<div>
					<div className="icon">
						<ImageGenerator src={chat} />
					</div>
					<span>
						برای ثبت نظر ابتدا وارد شوید
					</span>
				</div>
				<div>
					<Button variant={'text'} onClick={() => setOpenRegisterDialog(true)}>
						<span>ورود و ثبت‌ نام</span>
					</Button>
				</div>
				<AuthenticationDialogHandler openRegisterDialog={openRegisterDialog}
											 setOpenRegisterDialog={setOpenRegisterDialog}/>
			</div>
		)
	}

	if (configApp?.titleEn === 'bebin' && !configApp?.sub_domain) {
		return (
			JSON.stringify(profile) === '{}' || !profile ? goToRegister() : <>
				<div className="comment-form">
					<div className="avatar">
						<ImageGenerator src={user} />
					</div>
					<form onSubmit={handleSubmit}>
				<textarea
					maxLength="500"
					value={comment}
					onChange={(e) => setComment(e.target.value)}
					placeholder="دیدگاهتان را بنویسید..."
				/>
						<button className="sender" type="submit" disabled={loading}>
							<ImageGenerator src={send} />
						</button>
					</form>
					<Toast toastList={successMessage}
						   position={'top-right'}
						   autoDelete={true}
						   dismissTime={7000} />
				</div>
			</>
		);
	}

	return null
};

export default CommentForm;
